import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap';
import Slider from 'react-slick';

export default function Testimonial() {


    useEffect(() => {
        var colors = ['#607d8b', '#795548', '#4caf50', '#9c27b0', '#dab03b', '#ca3db7', '#23753b', '#32579d', '#75aee0', '#ff5722', '#4caf50', '#37bf3b', '#607d8b', '#795548', '#4caf50', '#9c27b0', '#dab03b', '#ca3db7', '#23753b', '#32579d', '#75aee0', '#ff5722', '#4caf50', '#37bf3b'];
        document.querySelectorAll('.menu_item').forEach(
            (el, i) => el.style.backgroundColor = colors[i]);
    }, [])

    var settings = {
        dots: true,

        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1500,
        autoplaySpeed: 3500,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },

        ]
    };
    return (
        <div className=" bg-image mx-0 mb-5" id='testimonial'>
            <Container>
                <div className=" py-5">
                    <div className="section-title text-center position-relative my-4">
                        <h6 className="d-inline-block position-relative secondary-text  text-uppercase pb-2">Testimonial</h6>

                        <h1 className="text-center mt-sm-2 mb-4">WHAT PEOPLE SAY</h1>
                    </div>

                    <Slider {...settings}>
                        <div className=' p-3'>
                            <div className='bg-white p-4'>

                                <div className='d-flex'>
                                    <div className='menu_item'><span>P</span></div> <div className='ms-3'> <h4>Parthavi Patil</h4></div>
                                </div>
                                <p>Amazing experience, ordered from Pune and we are extremely satisfied with the final product and how it enhances the whole look of our home. Would definitely recommend this place, affordable and worth it. They have track curtains as well as rod curtains.</p>
                            </div>
                        </div>
                        <div className=' p-3'>
                            <div className='bg-white p-4'>

                                <div className='d-flex'>
                                    <div className='menu_item'><span>H</span></div> <div className='ms-3'> <h4>Hiren Khichadiya</h4></div>
                                </div>
                                <p>Absolutely thrilled with my purchase from Krishna Handloom & curtains! The quality of the curtains exceeded my expectations, and the variety of styles made it easy to find the perfect match for my home decor. Plus, the customer service was exceptional – they guided me through the selection process with patience and expertise. Highly recommend</p>
                            </div>
                        </div>
                        <div className=' p-3'>
                            <div className='bg-white p-4'>

                                <div className='d-flex'>
                                    <div className='menu_item'><span>D</span></div> <div className='ms-3'> <h4>Dharmil Vekariya</h4></div>
                                </div>
                                <p>I've purchased curtains from several shops before, but none have compared to the experience I had with Krishna Handloom & curtains. The customization options were fantastic, allowing me to create curtains that fit my windows perfectly. Not to mention, the durability of the fabric is impressive – they still look as good as new after months of use.</p>
                            </div>
                        </div>
                        <div className=' p-3'>
                            <div className='bg-white p-4'>

                                <div className='d-flex'>
                                    <div className='menu_item'><span>D</span></div> <div className='ms-3'> <h4>D&D startups idea</h4></div>
                                </div>
                                <p>I've been a loyal customer of Krishna Handloom & curtains for years, and for good reason. The consistently high quality of their products and the level of care they put into every order is unmatched. Whether I'm ordering standard sizes or custom curtains, I know I can trust Krishna Handloom & curtains to deliver excellence every time</p>
                            </div>
                        </div>
                        <div className=' p-3'>
                            <div className='bg-white p-4'>

                                <div className='d-flex'>
                                    <div className='menu_item'><span>P</span></div> <div className='ms-3'> <h4>Parmar Divyang</h4></div>
                                </div>
                                <p>From start to finish, my experience with Krishna Handloom & curtains was fantastic. The website was easy to navigate, making it simple to find exactly what I was looking for. The ordering process was straightforward, and the curtains arrived sooner than expected. I'm thrilled with the results – my room feels like a whole new space!</p>
                            </div>
                        </div>
                        <div className=' p-3'>
                            <div className='bg-white p-4'>

                                <div className='d-flex'>
                                    <div className='menu_item'><span>D</span></div> <div className='ms-3'> <h4>Dhaval Goti</h4></div>
                                </div>
                                <p>What a seamless shopping experience! From browsing the website to delivery and installation, everything was top-notch. The curtains arrived on time and were even more beautiful in person. I appreciated the attention to detail in the craftsmanship, and I've received countless compliments from guests. Thank you, Krishna Handloom & curtains!"</p>
                            </div>
                        </div>
                        <div className=' p-3'>
                            <div className='bg-white p-4'>

                                <div className='d-flex'>
                                    <div className='menu_item'><span>K</span></div> <div className='ms-3'> <h4>Kavya Babariya</h4></div>
                                </div>
                                <p>I'm not usually one to leave reviews, but I had to make an exception for Krishna Handloom & curtains. The customer service team went above and beyond to ensure I was satisfied with my purchase. They were incredibly responsive to my questions and provided helpful recommendations based on my preferences. I couldn't be happier with my new curtains!</p>
                            </div>
                        </div>
                        <div className=' p-3'>
                            <div className='bg-white p-4'>

                                <div className='d-flex'>
                                    <div className='menu_item'><span>J</span></div> <div className='ms-3'> <h4>Jeel Thummar</h4></div>
                                </div>
                                <p>I've been searching for the perfect curtains for months, and I finally found them at Krishna Handloom & curtains. The selection is unmatched, with a wide range of colors and patterns to choose from. I appreciated the option to request fabric samples, which helped me make my decision with confidence. The curtains arrived quickly and were expertly crafted – I'll definitely be back for more!</p>
                            </div>
                        </div>
                        <div className=' p-3'>
                            <div className='bg-white p-4'>

                                <div className='d-flex'>
                                    <div className='menu_item'><span>D</span></div> <div className='ms-3'> <h4>Deep Dobariya</h4></div>
                                </div>
                                <p>After a disappointing experience with curtains from another shop, I was hesitant to try again. But I'm so glad I did! The curtains I ordered from Krishna Handloom & curtains are exactly what I was looking for. The quality is exceptional, and they add the perfect finishing touch to my living room. I can't recommend them enough!</p>
                            </div>
                        </div>


                    </Slider>
                </div>
            </Container>

        </div>
    )
}
